module.exports = __webpack_public_path__ + "images/index/img03.b6e193d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/children/new/img03.jpeg
// module id = cOpb
// module chunks = 21